// extracted by mini-css-extract-plugin
export default {"root":"styles_root__A9IFV","label":"styles_label__aAUBs","selected":"styles_selected__k+SWO","active":"styles_active__KMo85","item":"styles_item__6AgxG"};